import { csv } from "d3-request";
import { emptyGeojson } from "../components/riskAssessment/defaultSourceLayer";

const makeGeoJSONforEathquakeMagnitude = (data: any): GeoJsonData => {
  return {
    type: "FeatureCollection",
    features: data.map((feature: any) => {
      return {
        type: "Feature",
        properties: {
          eventId: feature.EventID,
          time: new Date(feature.Time),
          depthKm: Number(feature.DepthKm),
          magType: feature.MagType,
          eventLocationName: feature.EventLocationName,
          mag: Number(feature.Magnitude),
        },
        geometry: {
          type: "Point",
          coordinates: [Number(feature.Longitude), Number(feature.Latitude)],
        },
      };
    }),
  };
};

const requestCsvPromise = (url: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    csv(url, (error, data) => {
      if (error) {
        reject(error);
      } else {
        resolve(data);
      }
    });
  });
};

export const getEarthquakeMagnitudeForItaly = async () => {
  try {
    const response = await requestCsvPromise(
      "https://cystellar-geojson.s3.amazonaws.com/ITALY_earthquakes.csv",
    );

    const geoJson = makeGeoJSONforEathquakeMagnitude(response);
    return geoJson;
  } catch (error) {
    console.error("Error fetching earthquake magnitude data:", error);
    return emptyGeojson;
  }
};
